export default function () {
  // quick fix to speed up site without removing all feature toggle code yet.
  return true
}
